import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

// Simple password hash for basic protection
// In production, this should be handled by a proper backend authentication system
const CORRECT_PASSWORD_HASH = 'estocks2025'  // The actual password

export const useAuthStore = defineStore('auth', () => {
  // State
  const isAuthenticated = ref(false)
  const sessionToken = ref<string | null>(null)

  // Check if user is already authenticated (from localStorage)
  const checkAuth = () => {
    const stored = localStorage.getItem('estocks_auth')
    if (stored) {
      try {
        const data = JSON.parse(stored)
        if (data.token && data.expiry > Date.now()) {
          isAuthenticated.value = true
          sessionToken.value = data.token
          return true
        } else {
          // Token expired
          logout()
        }
      } catch (e) {
        logout()
      }
    }
    return false
  }

  // Login function
  const login = (password: string): boolean => {
    // Simple password check
    if (password === CORRECT_PASSWORD_HASH) {
      isAuthenticated.value = true
      
      // Create session token (valid for 24 hours)
      const token = btoa(`${password}:${Date.now()}`)
      sessionToken.value = token
      
      // Store in localStorage with expiry (24 hours)
      const expiry = Date.now() + (24 * 60 * 60 * 1000)
      localStorage.setItem('estocks_auth', JSON.stringify({
        token,
        expiry
      }))
      
      return true
    }
    
    return false
  }

  // Logout function
  const logout = () => {
    isAuthenticated.value = false
    sessionToken.value = null
    localStorage.removeItem('estocks_auth')
  }

  // Initialize auth state
  checkAuth()

  return {
    isAuthenticated,
    sessionToken,
    login,
    logout,
    checkAuth
  }
})

